import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b4760c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  slot: "start",
  class: "fal fa-filter",
  style: {"margin-right":"10px"}
}, null, -1))
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-bell",
  style: {"color":"red"}
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-circle-info",
  slot: "icon-only"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-heart",
  slot: "icon-only"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-calendar fa-2x",
  style: {"margin":"5px"}
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-heart fa-2x",
  style: {"margin":"5px"}
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-list fa-2x",
  style: {"margin":"5px"}
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-eye fa-2x",
  style: {"margin":"5px"}
}, null, -1))

import { getApi } from '@/helpers/api';
import {
  IonContent, IonHeader, IonPage, IonButtons, IonMenuButton,
  IonTitle, IonButton, IonGrid, IonCol, IonRow, IonTab, IonTabBar, IonTabButton, IonTabs,
  IonToolbar, IonCard, IonSearchbar,/*IonSelect, IonSelectOption,*/ IonCardContent, IonCardTitle, IonCardSubtitle, IonCardHeader
} from '@ionic/vue';
import { GetAllDomainResponse, GetAllModuleResponse, TrainingsApi } from 'ppf-api-client';
import { ref } from 'vue';
import { useRouter } from 'vue-router';




export default /*#__PURE__*/_defineComponent({
  __name: 'ContentPage',
  setup(__props) {

const router = useRouter();
const trainingService = getApi(TrainingsApi);
const domains = ref<GetAllDomainResponse[]>([]);
const modules = ref<GetAllModuleResponse[]>([]);
let allModules: GetAllModuleResponse[] = [];
const titles = ref<{id: number, label: string, type: 'doc'|'pdf'|'video', notif: boolean}[][]>([
  [
    {id: 1, label: 'Mode opératoire', type: 'doc', notif: false},
    {id: 2, label: 'Checklists de nettoyage', type: 'pdf', notif: false},
  ],
  [
    {id: 3, label: 'Checklists de démarrage', type: 'doc', notif: false},
  ],
  [
    {id: 4, label: 'Mode opératoire', type: 'doc', notif: false},
  ],
  [
    {id: 5, label: 'Fiche de poste', type: 'pdf', notif: true},
    {id: 6, label: 'Mode opératoire', type: 'doc', notif: false},
    {id: 7, label: 'Checklists de démarrage et fin de poste', type: 'doc', notif: false},
  ],
  [
    {id: 8, label: 'Conduite défensive', type: 'doc', notif: false},
    {id: 9, label: 'Fiche de poste', type: 'pdf', notif: true},
  ],
  [
    {id: 10, label: 'Règles de sécurité en entrepôt', type: 'video', notif: true},
  ],
  [
    {id: 11, label: 'Mode opératoire', type: 'doc', notif: false},
    {id: 12, label: 'Checklists de nettoyage', type: 'pdf', notif: false},
  ],
  [
    {id: 13, label: 'Checklists de démarrage', type: 'doc', notif: false},
  ],
  [
    {id: 14, label: 'Mode opératoire', type: 'doc', notif: false},
  ],
  [
    {id: 15, label: 'Fiche de poste', type: 'pdf', notif: true},
    {id: 16, label: 'Mode opératoire', type: 'doc', notif: false},
    {id: 17, label: 'Checklists de démarrage et fin de poste', type: 'doc', notif: false},
  ],
  [
    {id: 18, label: 'Mode opératoire', type: 'doc', notif: false},
  ],
  [
    {id: 19, label: 'Checklists de démarrage de poste', type: 'pdf', notif: false},
    {id: 20, label: 'Consignes de nettoyage et rangement', type: 'pdf', notif: false},
  ],
  
  
]);
const iconSrcs = ref<any>({
  pdf: 'https://cdn1.iconfinder.com/data/icons/ios-web-user-interface-square-rounded-shadow-vol-7/512/Document_file_export_sending_exit_send-512.png', 
  doc: 'assets/img/3016779.png',
  video: 'https://cdn1.iconfinder.com/data/icons/ios-web-user-interface-square-rounded-vol-6/512/Document_extension_file_list_menu_text-1024.png'})

trainingService.trainingsGetAllDomainModules().then(x => {
  domains.value = x.domains;
  allModules = x.modules.sort(sortByProperty<GetAllModuleResponse>('displayText'));
  modules.value = allModules;
});

function sortByProperty<T>(propertyName: keyof T): ((a: T, b: T) => number) {
  return function (a: T, b: T) {
    const nameA = (typeof a[propertyName] === 'string') ? ((a[propertyName] as string).toUpperCase() || '') : a[propertyName]; // ignore upper and lowercase
    const nameB = (typeof b[propertyName] === 'string') ? ((b[propertyName] as string).toUpperCase() || '') : b[propertyName]; // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  };
}

function goToDocument(docId: number) {
    router.push(`/document/${docId}`);
}
// function filterChanged(event: any) {
//   modules.value = allModules.filter(x => x.domainId == event.detail.value);
// }

return (_ctx: any,_cache: any) => {
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_badge = _resolveComponent("ion-badge")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonTabs), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonTab), { tab: "radio" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonHeader), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonToolbar), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButtons), { slot: "start" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonMenuButton))
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonTitle), null, {
                        default: _withCtx(() => [
                          _createTextVNode("Mes contenus")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonButtons), { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), { id: "open-modal" }, {
                            default: _withCtx(() => [
                              _hoisted_1,
                              _createTextVNode(" Filtrer ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonToolbar), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonSearchbar), {
                        animated: true,
                        placeholder: "Rechercher..."
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonContent), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonGrid), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonRow), null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modules.value, (module, mIdx) => {
                            return (_openBlock(), _createBlock(_unref(IonCol), {
                              size: "12",
                              "size-sm": "4",
                              key: module.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonCard), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonCardHeader), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonCardTitle), null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(module.displayText), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_unref(IonCardSubtitle), null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(module.domainDisplayText), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_unref(IonCardContent), null, {
                                      default: _withCtx(() => [
                                        (titles.value[mIdx] != undefined)
                                          ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(titles.value[mIdx], (title) => {
                                                  return (_openBlock(), _createBlock(_component_ion_item, {
                                                    key: 'title'+title.id,
                                                    onClick: ($event: any) => (goToDocument(title.id))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("img", {
                                                            style: {"padding":"3px"},
                                                            alt: "RTF",
                                                            src: iconSrcs.value[title.type]
                                                          }, null, 8, _hoisted_2)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_ion_label, null, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("h2", null, _toDisplayString(title.label), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      (title.notif)
                                                        ? (_openBlock(), _createBlock(_component_ion_label, {
                                                            key: 0,
                                                            slot: "end"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _hoisted_3
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_unref(IonToolbar), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonButtons), { slot: "start" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonButton), null, {
                                              default: _withCtx(() => [
                                                _hoisted_4
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(IonButtons), { slot: "end" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonButton), null, {
                                              default: _withCtx(() => [
                                                _hoisted_5
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonTab), { tab: "home" }),
          _createVNode(_unref(IonTab), { tab: "library" }),
          _createVNode(_unref(IonTab), { tab: "today" }),
          _createVNode(_unref(IonTabBar), { slot: "bottom" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTabButton), { tab: "today" }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createTextVNode(" Aujourd'hui ")
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), { tab: "home" }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createTextVNode(" Favoris ")
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), { tab: "radio" }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createTextVNode(" Tous ")
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), { tab: "library" }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _createTextVNode(" A consulter "),
                  _createVNode(_component_ion_badge, { color: "danger" }, {
                    default: _withCtx(() => [
                      _createTextVNode("7")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})